import { Component, OnInit } from '@angular/core';
import { timeout } from 'rxjs/operators';
import { VehicleService } from 'src/app/vehicles/services/vehicle.service';
import { EventService } from 'src/app/events/services/event.service';
import { UserDataService } from 'src/app/profile-config/services/user-data.service';
import { environment } from 'src/environments/environment';
import { MomentService } from 'src/app/vehicles/services/moment.service';
import { UserTracker } from 'src/app/multiview/models/interfaces';
import { NgxSpinnerService } from 'ngx-spinner';

import { HttpClient } from '@angular/common/http';
import { CustomToastMessagessService } from 'src/app/map/services/custom-toast-messagess.service';

@Component({
  selector: 'app-report-csv',
  templateUrl: './report-csv.component.html',
  styleUrls: ['./report-csv.component.scss']
})
export class ReportCsvComponent implements OnInit {
  eventEvaluationOptions = [
    { label: 'Todos', value: null },
    { label: 'Evaluados', value: 1 },
    { label: 'No evaluados', value: false }
  ];

  fileInfo: {
    sizeKB: string;
    rows: number;
    columns: number;
  } | null = null;

  csvLoading = false;

  selectedEventEvaluation: number | boolean | null = null;
  userId: any;
  today: Date = new Date();
  dateInit: Date = new Date();
  dateEnd: Date = new Date();
  timeInit: Date = new Date();
  timeEnd: Date = new Date();
  areHoursValid = true;

  isUserIdLoaded: boolean = false;
  

  areVehiclesLoaded = false

  listOptions: any = [
    { idOption: 'Mostrar Todos los Vehículos', valueOption: 'all' },
    { idOption: 'Operación', valueOption: 'operacion' },
    { idOption: 'Grupo', valueOption: 'grupo' },
    { idOption: 'Convoy', valueOption: 'convoy' }
  ];

  selectedEvents: any = [];
  events: any[] = []
  
  selectedVehicles: any = []; // vehiculos seleccionados
  selectableVehicles : any = [] // vehiculos disponibles para selccionar
  vehicles: any[] = [] // all vehicles
  
  
  selectedOperation: any = {};
  disabledOperation: boolean = true;
  operations: any[] = [];
  renderOperations: boolean = false;

  selectedGroup: any = {};
  disabledGroup: boolean = true;
  groups: any[] = [];
  renderGroups: boolean = false;

  selectedConvoy: any = {};
  disabledConvoy: boolean = true;
  convoys: any[] = [];
  renderConvoys: boolean = false;

  
  filterVehiclesBy : string = 'all'


  placeholderOperation = 'Seleccione una Operación ...';
  placeholderGroup = 'Seleccione una Operación Primero...';
  placeholderConvoy = 'Seleccione una Operación Primero...';

  constructor(
    private useService: UserDataService,
    private eventService: EventService,
    private vehicleService: VehicleService,
    private spinner: NgxSpinnerService,
    private http: HttpClient,
    private moment: MomentService,
    private customToastMessagess: CustomToastMessagessService,
  ) {
    // Hora inicio en 00:00
    this.timeInit.setHours(0, 0, 0, 0);
    // Hora fin en 23:59
    this.timeEnd.setHours(23, 59, 0, 0);
  }

  public strYearRange : string = "";
  ngOnInit(): void {
    this.getUserId();
    this.strYearRange = '2000:' + new Date().getFullYear();

    //this.getVehicles();
    this.eventService.getEventsForUser().subscribe(async (data) => {

      if (data.success) {
        this.events = data.data;
        this.events = this.events.map((event: any) => ({
          ...event,
          active: false,
        }));
      } else {
        this.events = [];
      }
    })
    if (this.vehicleService.vehicles.length > 0) {
      this.vehicles = this.vehicleService.vehicles
      this.selectableVehicles = this.vehicleService.vehicles
        this.loadOperationsFromVehicles();
    } else {
      this.vehicleService.dataCompleted.subscribe((vehicles) => {
        this.vehicles = vehicles
        this.selectableVehicles = this.vehicleService.vehicles
        this.loadOperationsFromVehicles();
      })
    }

  }

  public getVehicles() {
    this.vehicleService.getVehicles().subscribe(async (vehicles) => {
      this.vehicles = vehicles
    });
  }
  isRangeExceeded: boolean = false;
  enviarPeticion() {
    const start = new Date(this.dateInit);
    start.setHours(this.timeInit.getHours(), this.timeInit.getMinutes(), 0, 0);

    const end = new Date(this.dateEnd);
    end.setHours(this.timeEnd.getHours(), this.timeEnd.getMinutes(), 0, 0);

    const currentYear = new Date().getFullYear();

    // Validar que ambas fechas estén dentro del mismo año actual
    const isSameYear = start.getFullYear() === currentYear && end.getFullYear() === currentYear;

    const diferenciaEnMs = end.getTime() - start.getTime();
    const diasDeDiferencia = diferenciaEnMs / (1000 * 60 * 60 * 24);

    // Validar que no exceda los 32 días y sea del mismo año
    if (!isSameYear || diasDeDiferencia > 32) {
      this.isRangeExceeded = true;
      return;
    } else {
      this.isRangeExceeded = false;
    }

    const imeis = this.selectedVehicles.map((vehicle: any) => vehicle.IMEI);
    const slugs = this.selectedEvents.map((event: any) => event.slug);

    this.spinner.show('loadingReportCsv');

    const payload = {
      vehicles: imeis,
      events: slugs,
      dateIni: start.toISOString(),
      dateEnd: end.toISOString(),
      tzDefault: this.moment.tzDefault,
      tzCustom: this.moment.tzCustom,
      tzOffset: this.moment.tzOffset,
      tzPHP: this.moment.tzPHP,
      user_id: this.userId,
      optionReportEvaluation: this.selectedEventEvaluation
    };
    console.log('Payload a enviar (JSON):', payload);
    this.spinner.show('loadingReportCsv');

    this.http.post(`${environment.apiUrl}/api/reports/eventos_cipia_atencion_export`, payload, {
      responseType: 'blob'
    }).pipe(
      timeout(300000) // ⏱️ 2 minutos de tiempo máximo
    ).subscribe({
      next: (response: Blob) => {
        this.spinner.hide('loadingReportCsv');
        const sizeKB = (response.size / 1024).toFixed(2);
        console.log(`Tamaño del archivo: ${sizeKB} KB`);

        const reader = new FileReader();
        reader.onload = () => {
          const text = reader.result as string;
          const rows = text.split('\n').filter(row => row.trim() !== '');
          const columnas = rows[0]?.split(',') ?? [];

          console.log(`Cantidad de filas: ${rows.length}`);
          console.log(`Cantidad de columnas: ${columnas.length}`);

          const blob = new Blob([text], { type: 'text/csv' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'reporte.csv';
          link.click();
          window.URL.revokeObjectURL(url);
        };
        reader.readAsText(response);
        this.isRangeExceeded = false;
      },
      error: (error) => {
        this.spinner.hide('loadingReportCsv');

        if (error.name === 'TimeoutError') {
          console.error('⏳ La solicitud superó el tiempo límite.');
          // Puedes mostrar un toast o alerta:
          // this.messageService.add({severity: 'warn', summary: 'Tiempo agotado', detail: 'No se pudo generar el reporte a tiempo'});
        } else {
          console.error('Error al obtener el archivo:', error);
        }
      }
    });

    // Aquí podrías usar algún servicio para enviarlo:
    // this.miServicio.enviarReporte(payload).subscribe(...)
  }


  get canSend(): boolean {
    return this.areHoursValid &&
      this.selectedVehicles.length > 0 &&
      this.selectedEvents.length > 0;
  }


  validateDateTimeRange() {
    if (!this.dateInit || !this.dateEnd || !this.timeInit || !this.timeEnd) {
      // Si falta alguna fecha u hora, considera válido (o como prefieras)
      this.areHoursValid = true;
      return;
    }

    // Construimos datetime completos
    const start = new Date(this.dateInit);
    const end = new Date(this.dateEnd);

    // Agregar horas y minutos de timeInit a start
    start.setHours(this.timeInit.getHours(), this.timeInit.getMinutes(), 0, 0);
    // Agregar horas y minutos de timeEnd a end
    end.setHours(this.timeEnd.getHours(), this.timeEnd.getMinutes(), 0, 0);

    // Comparar
    this.areHoursValid = start <= end;
  }

  public getUserId() {
    this.http.get(environment.apiUrl + '/api/userId').subscribe({
      next: data => {
        this.userId = parseInt(JSON.stringify(data));
        this.isUserIdLoaded = true;
      },
    });
  }


  private loadOperationsFromVehicles() {
    let aux: any[] = [];
    aux = this.vehicles
    for (const vehicle of aux) {
      const id_operation = vehicle.idoperation;
      const filteredOperation = {
        idoperation: vehicle.idoperation,
        nameoperation: vehicle.nameoperation,
      };
      if (!this.operations.some((op:any) => op.idoperation === id_operation)) {
        this.operations.push(filteredOperation);
      }
    }
    this.operations.sort((a: { idoperation: number; }, b: { idoperation: number; }) => a.idoperation - b.idoperation);
  }

  public onVehicleFilterChange(){

    switch (this.filterVehiclesBy) {
      case 'operacion':
        this.disabledOperation = false;
        this.disabledGroup = true;
        this.disabledConvoy = true;
        this.selectedVehicles = []
        break;

      case 'grupo':
        this.disabledOperation = false;
        this.disabledGroup = false;
        this.disabledConvoy = true;
        this.selectedVehicles = []
        break;

      case 'convoy':
        this.disabledOperation = false;
        this.disabledGroup = false;
        this.disabledConvoy = false;
        this.selectedVehicles = []
        break;
      default:
        this.disabledOperation = true;
        this.disabledGroup = true;
        this.disabledConvoy = true;
        this.selectedVehicles = []
        this.selectableVehicles = this.vehicles;
        break;
    }

    this.groups = [];
    this.convoys = [];
    this.selectedOperation = '';
    this.selectedGroup = '';
    this.selectedConvoy = '';
    this.placeholderOperation = 'Seleccione una Operación ...';
    this.placeholderGroup = 'Seleccione una Operación Primero...';
    this.placeholderConvoy = 'Seleccione una Operación Primero...';
  }




  onChangeOperation(){
    this.selectedGroup = '';
    this.selectedConvoy = '';
    this.groups = [];
    this.convoys = [];
    this.selectedVehicles = [];
    let aux:any[] =[];
    let aux2:any[] =[];

    console.log(this.selectedOperation)
    if (this.filterVehiclesBy == 'grupo' || this.filterVehiclesBy == 'convoy'){
       //filtrar grupos en base a operacion seleccionada
      aux = this.vehicles.filter((gp:any) => gp.idoperation==this.selectedOperation);
      for (const vehicle of aux) {
        const id_grupo = vehicle.idgrupo;
        const filteredGroup = {
          idgrupo: vehicle.idgrupo,
          namegrupo: vehicle.namegrupo,
          idconvoy: vehicle.idconvoy,
          nameconvoy: vehicle.nameconvoy,
          idoperation: vehicle.idoperation,
          nameoperation: vehicle.nameoperation,
        };
        if (!this.groups.some((gp:any) => gp.idgrupo === id_grupo)) {
          this.groups.push(filteredGroup);
        }
      }
      this.groups.sort((a: { idgrupo: number; }, b: { idgrupo: number; }) => a.idgrupo - b.idgrupo);

      this.disabledGroup = false;
      this.placeholderGroup = 'Seleccione un Grupo...';
      this.placeholderConvoy = 'Seleccione un Grupo Primero...';
    }
    //filtrar vehiculos
    aux2 = this.vehicles.filter((vh: any) => vh.idoperation == this.selectedOperation);
    this.selectableVehicles = aux2;

    console.log('Groups: ', this.groups);
    console.log('Vehicles: ', this.selectableVehicles);

  }
  onChangeGrupos() {
  this.selectedConvoy = '';
    this.convoys = [];
    this.selectedVehicles = [];

    let aux:any[] =[];
    let aux2:any[] =[];

    if (this.filterVehiclesBy == 'convoy'){
       //filtrar grupos en base a operacion seleccionada
      aux = this.selectableVehicles.filter((cv:any) => cv.idgrupo==this.selectedGroup && cv.idoperation == this.selectedOperation);
      for (const vehicle of aux) {
        const id_convoy = vehicle.idconvoy;
        const filteredGroup = {
          idgrupo: vehicle.idgrupo,
          namegrupo: vehicle.namegrupo,
          idconvoy: vehicle.idconvoy,
          nameconvoy: vehicle.nameconvoy,
        };
        if (!this.convoys.some((cv:any) =>cv.idconvoy === id_convoy)) {
          this.convoys.push(filteredGroup);
        }
      }
      this.disabledConvoy = false;
      this.placeholderConvoy = 'Seleccione un Convoy con Grupos..';
      this.convoys.sort((a: { idconvoy: number; }, b: { idconvoy: number; }) => a.idconvoy - b.idconvoy);
    }

    //filtrar vehiculos
    aux2 = this.vehicles.filter((vh:any) => vh.idgrupo == this.selectedGroup && vh.idoperation == this.selectedOperation);
    this.selectableVehicles = aux2;
    console.log('Convoys: ',this.convoys);
    console.log('Vehicles: ',this.selectableVehicles);
  }
  onChangeConvoys() {
    this.selectedVehicles = [];
    let aux:any[] =[];
    aux = this.vehicles.filter((vh:any) => vh.idconvoy == this.selectedConvoy && vh.idgrupo == this.selectedGroup && vh.idoperation == this.selectedOperation);
    this.selectableVehicles = aux;

    console.log('Vehicles: ', this.selectableVehicles);
  }


}
